import React from "react";
import { Card } from "@mui/material";
import { T } from "theme/tokens";

// A flat bordered panel. Shadows are avoided deliberately: the dashboard
// stacks a lot of panels, and elevation on all of them reads as noise.
export default function Surface({ children, sx, ...rest }) {
  return (
    <Card
      elevation={0}
      sx={{
        bgcolor: T.surface,
        border: `1px solid ${T.border}`,
        borderRadius: 3,
        boxShadow: "none",
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Card>
  );
}
